import { CartViewEvent } from '@/usecases/event-bus-for-third-party/event'

/**
 * @see https://my-color.esa.io/posts/1256
 */
export function handleCartViewEvent(event: CartViewEvent): void {
  if (event.purchasableDisplayItemList.length === 0) {
    return
  }

  window.dataLayer.push({
    event: 'smb_cart_view',
    products: event.purchasableDisplayItemList.map(cartItem => ({
      sku_number: cartItem.skuNumber,
      price: cartItem.unitPrice,
    })),
    total_price: event.totalPrice,
  })
}
